import apiEndpoints from "../endpoints";
import apiClient from "../exportClient";

// Login credentials interface
interface LoginCredentials {
  email: string;
  password: string;
}

// Backend sends 'forgotPassaword' - keep endpoint name as-is for compatibility
const authApis = () => {
  return {
    getProfile: {
      queryKey: ["get-user-profile"],
      queryFn: () => {
        return apiClient.get(apiEndpoints.auth.getProfile);
      },
    },
    login: {
      mutationKey: ["login"],
      mutationFn: async (credentials: LoginCredentials) => {
        return apiClient.post(apiEndpoints.auth.login, credentials);
      },
    },
  };
};

export default authApis;
